import React, { useState, useEffect } from 'react';
import companyService from '../../services/companyService';
import type { ICompany } from '../../types/company';
import Loader from '../../components/common/Loader';

const PlacementsPage: React.FC = () => {
  const [companies, setCompanies] = useState<ICompany[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      setIsLoading(true);
      try {
        const data = await companyService.getAllCompanies();
        setCompanies(data);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  if (isLoading) return <Loader />;

  return (
    <div className="py-10 px-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-10">Our Hiring Partners</h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 items-center">
          {companies.map(company => (
            <div key={company._id} className="flex justify-center items-center p-4">
              <img src={company.logo} alt={company.name} className="max-h-16 w-auto" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlacementsPage;